import axios from "axios";
import { Markup } from "interweave";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import EnterImage from "../../../../../../../../assets/images/actionBlue.png";
import cup from "../../../../../../../../assets/images/pending3.png";
import AuditionCardReuse from "../../../../../../../AuditionAdmin/AuditionCardReuse";
import AllDataHeader from "../../../../../../../Reuseable/AllDataHeader";
import LoaderPost from "../../../../../../../Reuseable/LoaderPost";
import EventsNav from "./EventsNav";
import "./PendingEventAudition.css";

const PendingEventAudition = () => {
  const [events, setEvents] = useState([]);
  const history = useHistory();
  const [buffer, setBuffer] = useState(true);
  useEffect(() => {
    axios.get("/api/audition-admin/audition/pendings").then((res) => {
      setBuffer(false);
      if (res.data.status === 200) {
        setEvents(res.data.event);
      }
    });
  }, []);

  const handleAcceptReject = (audition_id, status) => {
    const fData = new FormData();
    fData.append("audition_id", audition_id);
    fData.append("status", status);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .post(`/api/audition-admin/audition/status/update`, fData)
        .then((res) => {
          setBuffer(false);
          if (res.data.status === 200) {
            swal("Success", res.data.message, "success");
            history.push("/audition-admin/audition/event/request-approve");
          } else {
            swal("error", res.data.message, "error");
          }
        });
    });
  };

  return (
    <>
      <EventsNav />

      <AllDataHeader title="Pending Event" image={cup} count={"Zero"} />

      {buffer ? (
        <LoaderPost />
      ) : (
        <AuditionCardReuse
          data={events}
          handleAcceptReject={handleAcceptReject}
          // urlLink={`/audition-admin/audition/round-video-distribute`}
          // url2={`/audition-admin/audition/star-promo-send-feedback`}
        />
      )}
    </>
  );
};

export default PendingEventAudition;
